var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"basketpopup-wrapper\"> <div class=\"basketpopup errorpopup errorpopup-{{$ctrl.showErrors}} {{$ctrl.errorLocation}}\"> <a href=\"javascript:void(0)\" ng-click=\"$ctrl.Close()\" class=\"close-button glyphicon glyphicon-remove-sign\"> </a> <p light-if=\"$ctrl.errors.length > 0\"> <span ng-repeat=\"error in $ctrl.errors track by $index\"> {{ error.Message | i18next:error.Params }} <br/> </span> </p> </div> </div>";
var id1="reservationErrors.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/reservationErrors/reservationErrors.html
// module id = 277
// module chunks = 2